export default __webpack_public_path__ + "static/media/time.daaf77dd.png";